var params = {
  type: "GET",
  url: "/search?view=json&q=variants.sku:" + SKU_variant + "&type=product",
  dataType: "json",
  success: function (data) {
    console.log(data);
    if (data.length > 0) {
      var $_stone_container = $("<ul />").addClass("stone_container");

      for (let i = 0; i < data.length; i++) {
        var productData = data[i];

        var $_stone_item = $("<li />").addClass("stone_item");
        $_stone_item.html(
          '<a href="' +
            productData.url +
            '" title="' +
            '" class="swatch_stone-' +
            '"><div class="image-container"><img style="max-width: 50px;" src="' +
            productData.thumbnail +
            '" alt="' +
            '"/></div> <div class="vendor">' +
            productData.vendor +
            "</div></a > "
        );

        $_stone_container.append($_stone_item);
      }

      $(".stoner_section").append($_stone_container);

      // Applying similar styling and animation to the generated dropdown
      $(".stone_container").addClass("custom-dropdown");
      $(".stone_container").find(".stone_item").addClass("dropdown-list");
      $(".stone_container").find(".stone_item a").addClass("selected-item");

      // Handle dropdown item c
      // Toggle class on stone_container click
      $(".stoner_section").on("click", function () {
        $(".custom-dropdown").toggleClass("dropdown-visible");
      });
    }
  },
  error: function (a, b, c) {
    console.log(a);
  },
};

if (SKU_variant) $.ajax(params);
